import React, { useMemo } from 'react';
import { ShipmentAddressCommand } from '@sdir/httpclient/lib/clients/aps/application';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { styles } from '@sdir/sds';
import CardRow from '../CardRow/CardRow';
import DisplayedShipmentAddress from './DisplayedShipmentAddress';

interface AddressOverviewProps {
  shipmentAddress?: ShipmentAddressCommand | null;
}

const AddressOverview: React.FC<AddressOverviewProps> = ({ shipmentAddress }) => {
  const intl = useIntl();
  const hasAddress = useMemo(() => {
    if (!shipmentAddress) return false;
    const { address, address2, country, zip, city } = shipmentAddress;
    return address !== '' || address2 !== '' || country !== '' || zip !== '' || city !== '';
  }, [shipmentAddress]);

  return (
    <>
      {hasAddress ? (
        <CardRow
          label={
            <AddressHeader>
              <p>{intl.formatMessage({ id: 'contactinfo.deliveryaddress' })}</p>
            </AddressHeader>
          }
        >
          <DisplayedShipmentAddress shipmentAddress={shipmentAddress || {}} />
        </CardRow>
      ) : null}
    </>
  );
};

const AddressHeader = styled.div`
  display: flex;
  align-items: center;
  * {
    font-size: 14px;
  }
  p {
    margin: 0 8px 0 0;
    color: ${styles.colors.font.text85};
    font-family: ${styles.fonts.stfMedium};
  }
  svg {
    margin-left: 4px;
  }
`;

export default AddressOverview;
